export class TaskData {
    id: number;
    userId: string;
    revisionTimestamp: string;
    callsPlaced: number;
    callsCompleted: number;
    data: string;
    uploaded: number = 0;
}

